import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Box, Text, Icon } from '@rebeldotcom/components'

const propTypes = {
  domain: PropTypes.object.isRequired,
}

const DomainOverview = ({ domain }) => {
  const { name, status, expiry, addOns } = domain
  return (
    <Stack alignSelf="center" pb={2} px={2}>
      <Text>{name}</Text>
      <Text>{status}</Text>
      <Text pb={1}>{expiry}</Text>
      <Box>
        {addOns.map((addOn, idx) => (
          <Icon
            key={idx}
            color={addOn.status ? 'greenDark' : 'greyLight'}
            height="1.5rem"
            mr={1}
            name={addOn.iconName}
            title={addOn.name}
            width="1.5rem"
          />
        ))}
      </Box>
    </Stack>
  )
}

DomainOverview.propTypes = propTypes
export { DomainOverview }
